import { Dispatch } from 'redux';

import { requestHandler } from '../../api';
import { EditDocumentsInput, EditDocumentsOutput } from './types';

export { DocumentOperationOrigin } from './types';

export const updateArrearRate = async (dispatch: any, data: any) => {
  const response = await requestHandler({
    method: 'patch',
    url: 'internal/document/arrearRate',
    data,
    dispatch,
  });
  if (response) return response.data;
};

export const editDocuments = async (
  dispatch: Dispatch,
  data: EditDocumentsInput,
): Promise<EditDocumentsOutput | undefined> => {
  const response = await requestHandler({
    method: 'patch',
    url: 'internal/document/editDocuments',
    data,
    dispatch,
  });
  if (response) return response.data;
};
